import React, { useState } from "react";

const DropdownMenu = ({ icon, menuItems, alignRight = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleItemClick = (itemOnClick) => {
    itemOnClick();
    closeMenu();
  }; // <-- You were missing this closing curly brace

  return (
    <div style={styles.dropdown}>
      <img
        src={icon}
        alt="Icon"
        style={styles.iconImage}
        onClick={toggleMenu}
      />
      {isOpen && (
        <>
          <div style={styles.overlay} onClick={closeMenu} />

          <div
            style={{
              ...styles.menu,
              left: alignRight ? "auto" : "0", // Position left if alignRight is false
              right: alignRight ? "0" : "auto", // Position right if alignRight is true
            }}
          >
            {menuItems.map((item, index) => (
              <div
                key={index}
                style={styles.menuItem}
                onClick={() => handleItemClick(item.onClick)}
              >
                <img src={item.icon} alt="Menu Icon" style={styles.menuIcon} />
                <span style={item.color ? { color: item.color } : undefined}>
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const styles = {
  dropdown: {
    position: "relative",
    display: "inline-block",
  },
  iconImage: {
    cursor: "pointer",
    width: "24px",
    height: "24px",
    filter: "var(--icon-filter)",
  },
  menu: {
    position: "absolute",
    top: "100%",
    left: 0, // Default to opening on the left
    backgroundColor: "var(--surface)",
    color: "var(--text)",
    border: "1px solid var(--border)",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.3)",
    padding: "8px",
    borderRadius: "8px",
    zIndex: 1001, // Ensures menu is above overlay
    minWidth: "max-content", // Ensures the width adapts based on content
    whiteSpace: "nowrap", // Prevents text wrapping for cleaner look
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    padding: "8px 10px",
    cursor: "pointer",
    borderRadius: "6px",
  },
  menuIcon: {
    width: "18px",
    height: "18px",
    marginRight: "10px",
    filter: "var(--icon-filter)",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black
    zIndex: 1000, // Layer below the dropdown
  },
};

export default DropdownMenu;
